<template>
	<div>
		<h3><i><translate>Contact Form</translate></i></h3>
		<v-form
			ref="form"
			action="/klantenservice/contact/submit"
			method="post"
		>
			<input
				type="hidden"
				name="csrfToken"
				:value="$csrfToken"
			>
			<v-row class="pt-1 pb-1 mt-0 mb-0">
				<v-col class="pt-0 pb-0 mt-0 mb-0">
					<text-field
						class="pt-0 pb-0 mt-0 mb-0"
						style="font-family: Arial"
						color="primary"
						name="initials"
						:label="$gettext('Initials') + '*'"
						:rules="[i => !!i ||'Please fill in your initials']"
						required
					/>
				</v-col>
				<v-col class="pt-0 pb-0 mt-0 mb-0">
					<text-field
						class="pt-0 pb-0 mt-0 mb-0"
						style="font-family: Arial"
						color="primary"
						name="lastName"
						:label="$gettext('Last name') + '*'"
						:rules="[i => !!i || $gettext('Please fill in your last name')]"
						required
					/>
				</v-col>
			</v-row>
			<v-row class="pt-1 pb-1 mt-0 mb-0">
				<v-col class="pt-0 pb-0 mt-0 mb-0">
					<text-field
						class="pt-0 pb-0 mt-0 mb-0"
						style="font-family: Arial"
						color="primary"
						name="email"
						:label="$gettext('Email') + '*'"
						:rules="[i => !!i ||$gettext('Please fill in your email')]"
						required
					/>
				</v-col>
				<v-col class="pt-0 pb-0 mt-0 mb-0">
					<text-field
						class="pt-0 pb-0 mt-0 mb-0"
						style="font-family: Arial"
						color="primary"
						name="policyNumber"
						:label="$gettext('Policy number')"
					/>
				</v-col>
			</v-row>
			<v-row class="pt-1 pb-1 mt-0 mb-0">
				<v-col class="pt-0 pb-0 mt-0 mb-0">
					<text-field
						class="pt-0 pb-0 mt-0 mb-0"
						color="primary"
						name="subject"
						:label="$gettext('Subject') + '*'"
						:rules="[i => !!i || $gettext('Please fill in the subject of your question')]"
						required
					/>
				</v-col>
			</v-row>
			<v-row class="pt-1 pb-0 mt-0 mb-0">
				<v-col class="pt-0 pb-0 mt-0 mb-0">
					<text-area
						class="pt-0 pb-0 mt-0 mb-0"
						style="font-family: Arial"
						color="primary"
						name="question"
						:label="$gettext('Question') + '*'"
						:rules="[i => !!i || $gettext('Please fill in your question')]"
						required
						rows="6"
						auto-grow
					/>
				</v-col>
			</v-row>
			<v-row class="pt-0 pb-0 mt-0 mb-0">
				<v-col>
					<v-btn
						class="pt-0 pb-0 mt-0 mb-0"
						color="primary"
						type="submit"
					>
						<translate>Submit</translate>
					</v-btn>
				</v-col>
			</v-row>
		</v-form>
	</div>
</template>

<script>
export default {
	name: 'ContactForm',
};
</script>
